import styled from 'styled-components'

const PageStyle = styled.main`
	&:not(.home):not(.our-mission) {
		margin-top: var(--headerHeightSize);
	}
`
export default PageStyle
